import { ReactElement } from "react";
import { never } from "client_legacy/ndaw/errors";
import { AvailableNotificationViewModel, NotificationKind } from "client/Api/Notifications/notifications";
import { AnnouncementCommentActions } from "./AnnouncementCommentActions";
import { EventCommentActions } from "./EventCommentActions";
import { KnowledgeItemCommentActions } from "./KnowledgeItemCommentActions";

export type ActivityActionsProps = {
	activity: AvailableNotificationViewModel;
};

export const ActivityActions = (props: ActivityActionsProps): ReactElement | null => {
	const {
		activity
	} = props;

	switch (activity.kind) {
		case NotificationKind.AnnouncementComment:
			return <AnnouncementCommentActions data={activity.data} />;
		case NotificationKind.EventComment:
			return <EventCommentActions data={activity.data} />;
		case NotificationKind.KnowledgeItemComment:
			return <KnowledgeItemCommentActions data={activity.data} />;
		case NotificationKind.KnowledgeItemReaction:
		case NotificationKind.Unknown:
		case NotificationKind.CrossStoreOperation:
		case NotificationKind.Maintenance:
		case NotificationKind.Announcement:
		case NotificationKind.NewMainAppPromotion:
		case NotificationKind.AppAccess:
		case NotificationKind.Custom:
		case NotificationKind.NewEmail:
		case NotificationKind.UserRequest:
		case NotificationKind.Birthday:
		case NotificationKind.BirthdayWish:
		case NotificationKind.BirthdayWishReaction:
		case NotificationKind.DocumentShared:
		case NotificationKind.KnowledgeItem:
		case NotificationKind.Event:
		case NotificationKind.AnnouncementReaction:
		case NotificationKind.AnnouncementCommentReaction:
		case NotificationKind.EventAttendance:
		case NotificationKind.AnnouncementCommentMention:
		case NotificationKind.CommunityPost:
		case NotificationKind.CommunityPostComment:
		case NotificationKind.CommunityPostCommentMention:
		case NotificationKind.CommunityPostReaction:
		case NotificationKind.CommunityPostCommentReaction:
		case NotificationKind.EventCommentMention:
		case NotificationKind.EventCommentReaction:
		case NotificationKind.EventReaction:
		case NotificationKind.KnowledgeItemCommentReaction:
		case NotificationKind.KnowledgeItemCommentMention:
		case NotificationKind.Community:
		case NotificationKind.CommunityMembership:
			return null;
		default:
			never(activity);
	}
};
ActivityActions.displayName="ActivityActions";